import { render, staticRenderFns } from "./UserABMComponent.vue?vue&type=template&id=4a5234bc&scoped=true"
import script from "./UserABMComponent.js?vue&type=script&lang=js&external"
export * from "./UserABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserABMComponent.vue?vue&type=style&index=0&id=4a5234bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5234bc",
  null
  
)

export default component.exports